import { Box as BaseBox, BoxProps } from "@chakra-ui/react";

export type BaseBoxProps = BoxProps;

export default BaseBox;
